import { Link } from 'react-router-dom';
import Logo from '../../components/Logo';
import Seo from '../../components/Seo';

export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="flex min-h-screen">
      <Seo title={title} />
      {/* Brand panel */}
      <div className="relative hidden w-1/2 flex-col justify-between bg-gradient-to-br from-maroon-800 to-maroon-950 p-12 text-white lg:flex">
        <div className="absolute inset-0 opacity-30" aria-hidden>
          <div className="absolute -right-10 top-10 h-72 w-72 rounded-full bg-gold-400 blur-3xl" />
          <div className="absolute -bottom-16 -left-16 h-80 w-80 rounded-full bg-maroon-600 blur-3xl" />
        </div>
        <Logo light />
        <div className="relative">
          <p className="eyebrow mb-3 text-gold-400">Zonta District 17 · Area 1</p>
          <h2 className="font-serif text-4xl font-bold text-white">Empowering women through service.</h2>
          <p className="mt-4 max-w-md text-cream-200">
            Sign in to manage stories, events, and community resources for Zonta District 17 Area 1.
          </p>
        </div>
        <p className="relative text-sm text-gold-300">District 17 · Area 1</p>
      </div>

      {/* Form panel */}
      <div className="flex w-full flex-col justify-center bg-surface-card px-6 py-12 lg:w-1/2 lg:px-20">
        <div className="mx-auto w-full max-w-sm">
          <div className="mb-8 lg:hidden">
            <Logo />
          </div>
          <h1 className="heading-brand text-2xl">{title}</h1>
          {subtitle && <p className="mt-2 text-sm text-ink-muted">{subtitle}</p>}
          <div className="mt-8">{children}</div>
          {footer && <div className="mt-6 text-center text-sm text-ink-muted">{footer}</div>}
          <p className="mt-8 text-center text-xs text-ink-muted">
            <Link to="/" className="hover:text-maroon-700">
              ← Back to website
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
